import * as React from 'react';
import { Link } from '@inertiajs/react';
import { FeaturedRecipe } from '../../types/landing';
import { route } from '../../utils/route';

interface RecipeCardProps {
  recipe: FeaturedRecipe;
}

export function RecipeCard({ recipe }: RecipeCardProps): React.ReactElement {
  const recipeUrl = route('recipes.show', { slug: recipe.slug });

  return (
    <Link href={recipeUrl} className="recipe-card">
      <style>{`
        .recipe-card {
          flex: 0 0 280px;
          scroll-snap-align: start;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          text-decoration: none;
          color: inherit;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .recipe-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.12);
        }

        .recipe-card-image-container {
          position: relative;
          width: 100%;
          aspect-ratio: 16/10;
          background: linear-gradient(135deg, #fff7e6 0%, #ffe0b2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .recipe-card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .recipe-card-placeholder {
          font-size: 48px;
          color: #d97706;
        }

        .recipe-card-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          background: #d97706;
          color: #fff;
          font-size: 11px;
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 4px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .recipe-card-content {
          padding: 16px;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .recipe-card-title {
          font-size: 16px;
          font-weight: 700;
          color: #333;
          margin-bottom: 6px;
          line-height: 1.3;
        }

        .recipe-card-pack-hint {
          font-size: 12px;
          color: #5cb85c;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .recipe-card-cta {
          margin-top: auto;
          padding-top: 10px;
          font-size: 13px;
          color: #d97706;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .recipe-card {
            flex: 0 0 240px;
          }
          .recipe-card-content {
            padding: 12px;
          }
          .recipe-card-title {
            font-size: 15px;
          }
        }
      `}</style>

      <div className="recipe-card-image-container">
        {recipe.image_url ? (
          <img
            src={recipe.image_url}
            alt={recipe.name}
            className="recipe-card-image"
            loading="lazy"
          />
        ) : (
          <div className="recipe-card-placeholder">
            <i className="fa fa-utensils"></i>
          </div>
        )}
        <div className="recipe-card-badge">
          <i className="fa fa-book"></i> Receta
        </div>
      </div>

      <div className="recipe-card-content">
        <div className="recipe-card-title">{recipe.name}</div>
        {recipe.pack && (
          <div className="recipe-card-pack-hint">
            <i className="fa fa-shopping-basket"></i>
            Pack disponible
          </div>
        )}
        <div className="recipe-card-cta">
          Ver receta <i className="fa fa-arrow-right"></i>
        </div>
      </div>
    </Link>
  );
}
